import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  OutlinedInput,
  InputAdornment,
  Autocomplete,
  Grid,
  TextField,
  Paper,
} from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
import AutoCompleteDropDown from "../../../components/auto-complete-dropdown";
import { useEffect, useState } from "react";
import { usePersistentState } from "../../../contexts/global-context";
import { GetLocalStorage } from "../../../utils/local-storage";
import { GET } from "../../../config/https";
import APIS from "../../../config/api";
import FullScreenLoader from "../../../components/full-screen-loader";

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 160,
  padding: theme.spacing(0, 1, 0, 1),
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const StyledSearch = styled(OutlinedInput)(({ theme }: any) => ({
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    boxShadow: theme.customShadows.z8,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

TableToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  options: PropTypes.string,
  onFilterName: PropTypes.func,
  onChangeOrganizer: PropTypes.func,
  category: PropTypes.any,
  onChange: PropTypes.any,
  value: PropTypes.any,
  handleChangeStates: PropTypes.any,
  statesValue: PropTypes.any,
  statesData: PropTypes.any,
};

export default function TableToolbar({
  numSelected,
  filterName,
  onFilterName,
  category,
  onChange,
  onChangeOrganizer,
  options,
  value,
  handleChangeStates,
  statesData,
}: any) {
  const [state]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [checked] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    let userData = GetLocalStorage("loginData");
    let params: any = {
      id: userData.id,
    };
    setLoader(true);
    await GET(APIS.GET_USER_BY_ID, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setUserData(res?.result);
        } else {
          console.log("GetUserData error");
        }
      })
      .catch((error) => {
        setLoader(false);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);
  const userRole = loginInfo.roles;

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledSearch
            fullWidth
            size="small"
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Order..."
            startAdornment={
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ color: "text.disabled", width: 20, height: 20 }}
                />
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AutoCompleteDropDown
            data={category}
            onChange={onChange}
            label={"title"}
            placeholder={"Event Name"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {userRole?.name === "Host" ? (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              id="combo-box-demo"
              options={options}
              value={userData?.companyName}
              onChange={onChangeOrganizer}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              disabled={checked}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
            />
          ) : (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              id="combo-box-demo"
              options={options}
              value={value}
              onChange={onChangeOrganizer}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AutoCompleteDropDown
            data={statesData}
            onChange={handleChangeStates}
            label={"displayName"}
            placeholder={"Select Status"}
          />
        </Grid>
      </Grid>
      <FullScreenLoader open={loader} />
    </StyledRoot>
  );
}
